/* Atlas PLP: storefront filtering (Shopify Search & Discovery) via the Section Rendering API,
   sort, category chips, column toggle, filter sidebar / mobile sheet, load more.
   Ported from ac-cat-v2 plp.js for sections/atlas-plp-main.liquid (any root with [data-plp]). */
(function () {
  if (window.__atlasPlp) return;
  window.__atlasPlp = true;

  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const isMobile = () => (window.Atlas && window.Atlas.isMobile ? window.Atlas.isMobile() : window.innerWidth < 1040);
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function removeValue(params, name, value) {
    const all = params.getAll(name);
    params.delete(name);
    all.forEach((v) => { if (v !== value) params.append(name, v); });
  }

  class Plp {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.thumbs = {};
      this.abort = null;
      this.rememberThumbs();
      this.pauseVideos();
      root.addEventListener('click', (e) => this.onClick(e));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { this.closeSort(); this.root.classList.remove('is-sheet'); }
      });
      window.addEventListener('popstate', () => this.load(location.pathname + location.search, false));
    }

    /* ───────── URL state ───────── */
    params() { return new URLSearchParams(location.search); }
    go(params) {
      params.delete('page');
      const qs = params.toString();
      const url = location.pathname + (qs ? '?' + qs : '');
      history.pushState({}, '', url);
      this.load(url, false);
    }
    sectionUrl(url) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(this.sectionId);
    }
    fetchRoot(url) {
      return fetch(this.sectionUrl(url), { signal: this.abort && this.abort.signal, headers: { Accept: 'text/html' } })
        .then((r) => r.text())
        .then((html) => new DOMParser().parseFromString(html, 'text/html').querySelector('[data-plp]'));
    }

    /* ───────── Re-render ───────── */
    load(url) {
      if (this.abort) this.abort.abort();
      this.abort = new AbortController();
      this.root.classList.add('is-loading');
      this.fetchRoot(url).then((next) => {
        if (!next) return;
        this.rememberThumbs();
        $$('[data-plp-swap]', this.root).forEach((el) => {
          const name = el.dataset.plpSwap;
          const fresh = $('[data-plp-swap="' + name + '"]', next);
          if (!fresh) return;
          if (name === 'fbody') el.innerHTML = fresh.innerHTML; else el.replaceWith(fresh);
        });
        this.restoreThumbs();
        this.pauseVideos();
        this.root.classList.remove('is-loading');
      }).catch((err) => {
        if (err && err.name === 'AbortError') return;
        this.root.classList.remove('is-loading');
      });
    }
    loadMore(btn) {
      const url = btn.dataset.nextUrl;
      if (!url) return;
      btn.disabled = true;
      this.fetchRoot(url).then((next) => {
        if (!next) { btn.disabled = false; return; }
        const grid = $('[data-plp-grid]', this.root);
        const more = $('[data-plp-grid]', next);
        if (grid && more) Array.from(more.children).forEach((c) => grid.appendChild(document.importNode(c, true)));
        const foot = $('[data-plp-swap="foot"]', this.root), nfoot = $('[data-plp-swap="foot"]', next);
        if (foot && nfoot) foot.replaceWith(nfoot);
        this.pauseVideos();
      }).catch(() => { btn.disabled = false; });
    }

    /* Chip thumbnails: keep the last known image per chip (counts/images follow the filtered products) */
    rememberThumbs() {
      $$('[data-plp-swap="chips"] .plp-chip', this.root).forEach((c) => {
        const img = $('img', c);
        if (img && img.getAttribute('src')) this.thumbs[c.dataset.key] = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') || '' };
      });
    }
    restoreThumbs() {
      $$('[data-plp-swap="chips"] .plp-chip', this.root).forEach((c) => {
        const ph = $('span.plp-chip__img', c), t = this.thumbs[c.dataset.key];
        if (ph && t) {
          const img = document.createElement('img');
          img.className = 'plp-chip__img'; img.alt = ''; img.src = t.src; img.width = 40; img.height = 40;
          if (t.srcset) img.srcset = t.srcset;
          ph.replaceWith(img);
        }
      });
    }
    pauseVideos() {
      if (!reduced()) return;
      $$('[data-plp-video]', this.root).forEach((v) => { v.removeAttribute('autoplay'); v.pause(); });
    }

    /* ───────── Sort menu ───────── */
    closeSort() {
      const m = $('[data-plp-sort-menu]', this.root), sc = $('[data-plp-sort-close]', this.root), b = $('[data-plp-sort-toggle]', this.root);
      if (m) m.hidden = true; if (sc) sc.hidden = true; if (b) b.setAttribute('aria-expanded', 'false');
    }
    toggleSort() {
      const m = $('[data-plp-sort-menu]', this.root), sc = $('[data-plp-sort-close]', this.root), b = $('[data-plp-sort-toggle]', this.root);
      if (!m) return;
      const open = m.hidden;
      m.hidden = !open; if (sc) sc.hidden = !open; if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    /* ───────── Density ───────── */
    setCols(btn) {
      const group = btn.closest('[data-plp-dens]'), key = group.dataset.plpDens, n = btn.dataset.plpCols;
      $$('[data-plp-cols]', group).forEach((b) => {
        const on = b === btn;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      this.root.style.setProperty('--plp-c-' + key, n);
      this.root.dataset['c' + key.charAt(0).toUpperCase() + key.slice(1)] = n;
    }

    /* ───────── Events ───────── */
    onClick(e) {
      const t = e.target;
      let el;

      if ((el = t.closest('[data-plp-more]'))) { this.loadMore(el); return; }

      if ((el = t.closest('[data-plp-filter]'))) {
        if (el.disabled) return;
        const p = this.params(), name = el.dataset.param, v = el.dataset.value;
        if (p.getAll(name).indexOf(v) > -1) removeValue(p, name, v); else p.append(name, v);
        this.go(p); return;
      }
      if ((el = t.closest('[data-plp-chip]'))) {
        const p = this.params(), name = el.dataset.param, v = el.dataset.value;
        p.delete(name);
        if (v) p.append(name, v);
        this.go(p); return;
      }
      if ((el = t.closest('[data-plp-price]'))) {
        const p = this.params(), on = el.classList.contains('is-on');
        p.delete(el.dataset.gteParam); p.delete(el.dataset.lteParam);
        if (!on) {
          if (el.dataset.gte) p.set(el.dataset.gteParam, el.dataset.gte);
          if (el.dataset.lte) p.set(el.dataset.lteParam, el.dataset.lte);
        }
        this.go(p); return;
      }
      if ((el = t.closest('[data-plp-remove]'))) {
        const p = this.params(); removeValue(p, el.dataset.param, el.dataset.value); this.go(p); return;
      }
      if ((el = t.closest('[data-plp-remove-price]'))) {
        const p = this.params(); el.dataset.params.split(',').forEach((n) => p.delete(n)); this.go(p); return;
      }
      if (t.closest('[data-plp-clear]')) {
        const p = this.params();
        Array.from(p.keys()).forEach((k) => { if (k.indexOf('filter.') === 0) p.delete(k); });
        if (t.closest('[data-clear-sort]')) p.delete('sort_by');
        this.go(p); return;
      }
      if ((el = t.closest('[data-plp-sort]'))) {
        const p = this.params(); p.set('sort_by', el.dataset.plpSort); this.closeSort(); this.go(p); return;
      }
      if (t.closest('[data-plp-sort-toggle]')) { this.toggleSort(); return; }
      if (t.closest('[data-plp-sort-close]')) { this.closeSort(); return; }

      if ((el = t.closest('[data-plp-toggle-filters]'))) {
        if (isMobile()) { this.root.classList.add('is-sheet'); return; }
        const off = this.root.classList.toggle('plp--side-off');
        const label = $('[data-plp-fbtn-label]', el);
        if (label) label.textContent = off ? el.dataset.labelShow : el.dataset.labelHide;
        return;
      }
      if (t.closest('[data-plp-close-sheet]')) { this.root.classList.remove('is-sheet'); return; }
      if ((el = t.closest('[data-plp-cols]'))) { this.setCols(el); return; }
    }
  }

  function init(scope) {
    $$('[data-plp]', scope || document).forEach((r) => { if (!r.__plp) r.__plp = new Plp(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
